// ClienteModal.js - Modal de criação de cliente reutilizável
import React, { useState } from 'react';
import axios from 'axios';
import './Clientes.css';
import { Icon } from './SharedComponents';

export default function ClienteModal({ onClose, onClienteCriado, empresaId }) {
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        telefone: '',
        nuit: '',
        endereco: '',
        cidade: '',
        provincia: '',
        segmento: 'Varejo',
        nivelFidelidade: 'Bronze',
        ativo: true
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    const api = axios.create({
        baseURL: '/api',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const resetForm = () => {
        setFormData({
            nome: '',
            email: '',
            telefone: '',
            nuit: '',
            endereco: '',
            cidade: '',
            provincia: '',
            segmento: 'Varejo',
            nivelFidelidade: 'Bronze',
            ativo: true
        });
        setMessage({ text: '', type: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({ text: '', type: '' });

        if (!formData.nome.trim()) {
            setMessage({ text: 'O nome do cliente é obrigatório', type: 'danger' });
            setLoading(false);
            return;
        }

        if (!formData.email.trim()) {
            setMessage({ text: 'O email é obrigatório', type: 'danger' });
            setLoading(false);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setMessage({ text: 'Email inválido', type: 'danger' });
            setLoading(false);
            return;
        }

        if (!empresaId) {
            setMessage({ text: 'Empresa não identificada', type: 'danger' });
            setLoading(false);
            return;
        }

        const dadosParaEnviar = {
            nome: formData.nome.trim(),
            email: formData.email.trim(),
            telefone: formData.telefone?.trim() || '',
            nuit: formData.nuit?.trim() || '',
            endereco: formData.endereco?.trim() || '',
            cidade: formData.cidade?.trim() || '',
            provincia: formData.provincia?.trim() || '',
            segmento: formData.segmento || 'Varejo',
            nivelFidelidade: formData.nivelFidelidade || 'Bronze',
            empresaId: empresaId,
            ativo: formData.ativo !== undefined ? formData.ativo : true
        };

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setMessage({ text: 'Sessão expirada. Faça login novamente.', type: 'danger' });
                setLoading(false);
                return;
            }

            const response = await api.post('/clientes', dadosParaEnviar);
            if (response.data) {
                setMessage({ text: 'Cliente criado com sucesso!', type: 'success' });
                const clienteCriado = response.data.data || response.data;
                setTimeout(() => {
                    resetForm();
                    if (onClienteCriado) onClienteCriado(clienteCriado);
                }, 1000);
            }
        } catch (err) {
            console.error('❌ Erro ao criar cliente:', err);
            setMessage({
                text: err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao criar cliente',
                type: 'danger'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay"  onClick={onClose}>
            <div className="modal-content"  onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3><Icon name="person_add" size={22} /> Adicionar Cliente</h3>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    {message.text && (
                        <div className={`modal-alert modal-alert-${message.type}`}>
                            <Icon name={message.type === 'success' ? 'check_circle' : 'error'} size={18} />
                            <span>{message.text}</span>
                            <button className="alert-close" onClick={() => setMessage({ text: '', type: '' })}>×</button>
                        </div>
                    )}
                    <form onSubmit={handleSubmit}>
                        <div className="modal-section">
                            <div className="form-group">
                                <label>Nome <span className="required">*</span></label>
                                <input type="text" name="nome" value={formData.nome} onChange={handleChange} required placeholder="Nome completo" />
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Email <span className="required">*</span></label>
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="cliente@email.com" />
                                </div>
                                <div className="form-group">
                                    <label>Telefone</label>
                                    <input type="tel" name="telefone" value={formData.telefone} onChange={handleChange} placeholder="+258 84 123 4567" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>NUIT</label>
                                    <input type="text" name="nuit" value={formData.nuit} onChange={handleChange} placeholder="NUIT" />
                                </div>
                                <div className="form-group">
                                    <label>Endereço</label>
                                    <input type="text" name="endereco" value={formData.endereco} onChange={handleChange} placeholder="Endereço completo" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Cidade</label>
                                    <input type="text" name="cidade" value={formData.cidade} onChange={handleChange} placeholder="Cidade" />
                                </div>
                                <div className="form-group">
                                    <label>Província</label>
                                    <input type="text" name="provincia" value={formData.provincia} onChange={handleChange} placeholder="Província" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Segmento</label>
                                    <select name="segmento" value={formData.segmento} onChange={handleChange}>
                                        <option value="Varejo">🛒 Varejo</option>
                                        <option value="Atacado">📦 Atacado</option>
                                        <option value="Corporativo">🏢 Corporativo</option>
                                        <option value="Premium">⭐ Premium</option>
                                        <option value="VIP">👑 VIP</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Nível de Fidelidade</label>
                                    <select name="nivelFidelidade" value={formData.nivelFidelidade} onChange={handleChange}>
                                        <option value="Bronze">🥉 Bronze</option>
                                        <option value="Prata">🥈 Prata</option>
                                        <option value="Ouro">🥇 Ouro</option>
                                        <option value="Platina">💎 Platina</option>
                                        <option value="Diamante">👑 Diamante</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group checkbox-group" style={{ marginTop: '0.5rem' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        name="ativo"
                                        checked={formData.ativo !== undefined ? formData.ativo : true}
                                        onChange={handleChange}
                                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                    />
                                    <span style={{ fontSize: '0.8rem', fontWeight: '500', color: 'var(--color-dark)' }}>
                                        Cliente Ativo
                                    </span>
                                    <small style={{ fontSize: '0.65rem', color: 'var(--color-info-dark)', marginLeft: '0.25rem' }}>
                                        (Desative para desativar o cliente)
                                    </small>
                                </label>
                            </div>
                        </div>
                        <div className="modal-actions">
                            <button type="submit" className="modal-btn-primary" disabled={loading}>
                                {loading ? 'A criar...' : 'Criar Cliente'}
                            </button>
                            <button type="button" className="modal-btn-secondary" onClick={resetForm}>Limpar</button>
                            <button type="button" className="modal-btn-secondary" onClick={onClose}>Cancelar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}